import Input from "@/ui/components/Input"
import Dropdown, { Option } from "@/ui/components/Dropdown"
import { RangeCalendar } from "@/ui/components/Calendar/RangeCalendar"
import dayjs from "dayjs"

import { directionFilterOptions, typeFilterOptions } from "./helper"

import { useMemo, type ChangeEvent, type FC } from "react"
import type { BalanceHistoryFilters } from "@/types/balances"
import type { SingleValue } from "react-select"
import type { ICompanyBank } from "@/types/company/IFullCompanyDto"

import style from "./style.module.scss"

type Props = {
  filters: BalanceHistoryFilters
  banks: ICompanyBank[]
  setFilters: (newFilters: BalanceHistoryFilters) => void
}

export const HistoryTableFilters: FC<Props> = ({ filters, banks, setFilters }) => {
  const banksOptions: Option[] = useMemo(
    () =>
      banks.map(el => ({
        value: String(el.id),
        label: `#${el.id} ${el.swift} - ${el.accountNumber} - ${el.currency}`
      })),
    [banks]
  )

  const handleContractorChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFilters({
      ...filters,
      contractor: e.target.value
    })
  }

  const handleOwnerChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFilters({
      ...filters,
      owner: e.target.value
    })
  }

  const handleDirectionChange = (option: SingleValue<Option>) => {
    setFilters({
      ...filters,
      direction: option?.value,
      direction_label: option?.label
    })
  }

  const handleTypeChange = (option: SingleValue<Option>) => {
    setFilters({
      ...filters,
      type: option?.value,
      type_label: option?.label
    })
  }

  const handleBankChange = (option: SingleValue<Option>) => {
    setFilters({
      ...filters,
      bank_id: option?.value,
      bank_label: option?.label
    })
  }

  const handleDateChange = (date: [Date | null, Date | null]) => {
    const [from, to] = date

    setFilters({
      ...filters,
      from: from ? dayjs(from).format("YYYY-MM-DD") : "",
      to: to ? dayjs(to).format("YYYY-MM-DD") : ""
    })
  }

  return (
    <div className={style.filtersWrapper}>
      <div className={style.upperFilters}>
        <RangeCalendar
          label="Выберите интервал"
          startDate={filters.from ? dayjs(filters.from).toDate() : null}
          endDate={filters.to ? dayjs(filters.to).toDate() : null}
          setSelectedDate={handleDateChange}
          maxDate={new Date()}
        />
        <Input
          placeholder="Название контрагента"
          label="Название контрагента"
          value={filters.contractor}
          onChange={handleContractorChange}
        />
        <Input
          placeholder="Название владельца"
          label="Название владельца"
          value={filters.owner}
          onChange={handleOwnerChange}
        />
      </div>
      <div className={style.bottomFilters}>
        <Dropdown
          label="Направление платежа"
          options={directionFilterOptions}
          value={{
            value: String(filters.direction),
            label: filters.direction_label
          }}
          onChange={handleDirectionChange}
          menuPlacement="auto"
        />
        <Dropdown
          label="Счет"
          options={banksOptions}
          value={{
            value: String(filters.bank_id),
            label: filters.bank_label
          }}
          onChange={handleBankChange}
          menuPlacement="auto"
          searchable
          clearable
        />
        <Dropdown
          label="Тип платежа"
          options={typeFilterOptions}
          value={{
            value: String(filters.type),
            label: filters.type_label
          }}
          onChange={handleTypeChange}
          menuPlacement="auto"
          searchable
        />
      </div>
    </div>
  )
}
